import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import MypageLayout from "./MypageLayout";
import { LeaveRequestBody } from "./LeaveRequestPage";
import { TimeCorrectionBody } from "./TimeCorrectionPage";
import { OvertimeBody } from "./OvertimePage";
import ApplyHistory from "./ApplyHistory";

// 社員の申請3種（休み申請・時間訂正・残業）を1画面のタブに集約した「申請ハブ」。
// タブは「新規申請フォーム」だけを切り替える。申請履歴は種別横断の共通一覧(ApplyHistory)を
// フォームの下に常設し、タブを切り替えても表示は変わらない（全種別まとめて新しい順）。
// 経営者はこれらのメニューを持たず承認リストで一括管理するため、ハブは社員向け。
const TABS = [
  { key: "leave", label: "休み", Body: LeaveRequestBody },
  { key: "correction", label: "時間訂正", Body: TimeCorrectionBody },
  { key: "overtime", label: "残業", Body: OvertimeBody },
];

// 旧ルートからの遷移時に ?tab=xxx で初期タブを指定できる（無指定/不正値は休み申請）。
function initialTab(search) {
  const t = new URLSearchParams(search).get("tab");
  return TABS.some((x) => x.key === t) ? t : "leave";
}

function ApplyHubPage() {
  const location = useLocation();
  const [tab, setTab] = useState(() => initialTab(location.search));
  // 申請が成立するたびに増やし、共通の申請履歴(ApplyHistory)に再取得のきっかけを渡す。
  const [reloadKey, setReloadKey] = useState(0);
  const Active = (TABS.find((t) => t.key === tab) || TABS[0]).Body;

  return (
    <MypageLayout active="apply" title="申請">
      <div className="mp-apptabs" role="tablist" aria-label="申請の種類">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={tab === t.key}
            className={`mp-apptab${tab === t.key ? " mp-on" : ""}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {/* タブで切り替わるのは新規申請フォームだけ。 */}
      <Active onChanged={() => setReloadKey((k) => k + 1)} />
      {/* 申請履歴は全種別まとめて常設（タブに依存しない）。 */}
      <ApplyHistory reloadKey={reloadKey} />
    </MypageLayout>
  );
}

export default ApplyHubPage;
